module.exports = __webpack_public_path__ + "static/3-3@3x-30bbd9fa5744ef78235c4162f015cef0.png";